import { render } from "./Logs.vue?vue&type=template&id=6767dc80"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__